import { useMemo } from "react";

import Helpers from "../../commons/helpers";
import { IReaction, IUserReaction } from "../../commons/interfaces";

interface IProps {
    reactionIcon: IReaction[];
    userReactions: IUserReaction[];
}

const ReactionCoppy = ({ userReactions, reactionIcon }: IProps) => {
    const data = useMemo(() => formatUserReact(userReactions || []), [userReactions]);

    return ((data || [])?.length > 0
        ? <div style={{ marginLeft: "16px", padding: "8px" }}>
            <div className="cr-reaction-total">
                {[...(data || [])].splice(0, 2).map((userReact, index) => {
                    const base64Icon =
                        reactionIcon.find((item) => Number(item.reactionCode) === Number(userReact?.reactionCode))?.emojiBase64 || "";
                    return <img key={index} alt="" src={`data:image/svg+xml;base64,${base64Icon}`} />;
                })}
                <p>{userReactions?.length}</p>
            </div>
        </div>
        : <></>
    );
};

const formatUserReact = (userReact: IUserReaction[]) => {
    if (userReact.length === 0) return;
    const result: { reactionCode: string; total: number }[] = [];
    const data: any = {};
    userReact.forEach((item) => {
        if (Helpers.isNullOrEmpty(data[item.reactionCode])) {
            data[item.reactionCode] = 1;
        } else {
            data[item.reactionCode] += 1;
        }
    });
    let arr = Object.entries(data);
    arr.forEach((item) => {
        result.push({
            reactionCode: String(item[0]),
            total: Number(item[1]),
        });
    });
    result.sort((a, b) => b.total - a.total);
    return result;
};

export default ReactionCoppy;
